'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.create = create;
exports.override = override;
exports.style = style;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _utilities = require('./utilities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
                                                                                                                                                                                                                              * @copyright 2015, Prometheus Research, LLC
                                                                                                                                                                                                                              */

/**
 * Create stylesheet from stylesheet spec.
 */
function create(spec) {
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var styleComponent = options.style || style;
  var stylesheet = {};
  for (var key in spec) {
    // istanbul ignore next
    if (!spec.hasOwnProperty(key)) {
      continue;
    }
    var item = spec[key];
    if ((0, _utilities.isComponent)(item)) {
      stylesheet[key] = item;
    } else {
      var _item$Component = item.Component;
      var Component = _item$Component === undefined ? 'div' : _item$Component;

      var componentStylesheet = _objectWithoutProperties(item, ['Component']);

      Component = styleComponent(Component, componentStylesheet, _extends({}, options, { displayName: options.displayName || key }));
      stylesheet[key] = Component;
    }
  }
  return stylesheet;
}

/**
 * Produce a new stylesheet by overriding keys from the original stylesheet with
 * values from spec.
 *
 * Note that as stylesheet is also a valid spec then this function can be used
 * to override one stylesheet with another.
 */
function override(stylesheet, spec) {
  var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

  if (!stylesheet) {
    return create(spec, options);
  }
  var styleComponent = options.style || style;
  stylesheet = _extends({}, stylesheet);
  for (var key in spec) {
    // istanbul ignore next
    if (!spec.hasOwnProperty(key)) {
      continue;
    }
    (0, _invariant2.default)(stylesheet[key] !== undefined, 'override(...): invalid override, stylesheet does not have key "%s"', key);
    var item = spec[key];
    if ((0, _utilities.isComponent)(item)) {
      stylesheet[key] = item;
    } else {
      var _spec$key = spec[key];
      var _spec$key$Component = _spec$key.Component;
      var Component = _spec$key$Component === undefined ? stylesheet[key] : _spec$key$Component;

      var componentStylesheet = _objectWithoutProperties(_spec$key, ['Component']);

      stylesheet[key] = styleComponent(Component, componentStylesheet, options);
    }
  }
  return stylesheet;
}

/**
 * Apply a stylesheet to a component.
 */
function style(Component, stylesheet) {
  var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

  (0, _invariant2.default)((0, _utilities.isComponent)(Component), 'Expected a valid React component, got: %s', typeof Component === 'undefined' ? 'undefined' : _typeof(Component));
  var displayName = (0, _utilities.getComponentDisplayName)(Component);
  if ((0, _utilities.isHostComponent)(Component)) {
    (0, _invariant2.default)(options.styleHostComponent, 'Found host component <%s /> but options.styleHostComponent(..) is not provided', displayName);
    return options.styleHostComponent(Component, stylesheet, { displayName: options.displayName || displayName });
  } else if (typeof Component.style === 'function') {
    return Component.style(stylesheet, options.displayName || displayName);
  } else if ((0, _utilities.isClassComponent)(Component)) {
    var _class, _temp;

    var nextStylesheet = override(Component.stylesheet || Component.defaultProps && Component.defaultProps.stylesheet, stylesheet, options);

    return _temp = _class = function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
      }

      return _class;
    }(Component), _class.displayName = options.displayName || displayName, _class.defaultProps = _extends({}, Component.defaultProps, {
      stylesheet: nextStylesheet
    }), _class.stylesheet = nextStylesheet, _class.Component = Component.Component || Component, _temp;
  } else if ((0, _utilities.isFunctionComponent)(Component)) {
    var _nextStylesheet = override(Component.stylesheet || Component.defaultProps && Component.defaultProps.stylesheet, stylesheet, options);

    var StyledComponent = function StyledComponent(props) {
      return Component(props);
    };
    StyledComponent.displayName = options.displayName || displayName;
    StyledComponent.defaultProps = _extends({}, StyledComponent.defaultProps, {
      stylesheet: _nextStylesheet
    });
    StyledComponent.stylesheet = _nextStylesheet;
    StyledComponent.Component = Component.Component || Component;
    return StyledComponent;
  } else {
    // istanbul ignore next
    (0, _invariant2.default)(false, 'Unable to style component: <%s />', (0, _utilities.getComponentDisplayName)(Component));
  }
}
